import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#323EDD",
    },
    secondary: {
      main: "#DD2E44",
    },
  },
});

export default theme;
